/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "./Entreprises.scss";
import Header from "Components/Header/Header";
import Footer from "Components/Footer/Footer";
import EntrepriseCard from "Components/GestionAdmin/GestionMembres/EntreprisesPartenaires/EntrepriseCard/EntrepriseCard";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import { InputText } from "primereact/inputtext";
import { HiSearch } from "react-icons/hi";
import { updatePagination } from "Redux/Actions/paginationActions";
import { useRef } from "react";
import { findManagementContentByLabel, sanitizeHtml } from "Services/functions";
import { useFetchGetPagination } from "Services/api";
import TempPagination from "Components/Pagination/TempPagination";
import ModalConnexion from "Components/Modal/ModalConnexion/ModalConnexion";
import Loader from "Components/Loader/loader";
import parse from "html-react-parser";
import { HTMLParseOptions } from "Services/htmlParseOptions";

const Entreprises = (props) => {
  const itemsPerPage = 12;
  const refCompany = useRef(null);
  const [keyword, setKeyword] = useState("");
  const [loginVisible, setLoginVisible] = useState(false);

  const [url, setUrl] = useState(null);
  const companiesQuery = useFetchGetPagination(url);

  useEffect(() => {
    filterCompanies("");
  }, []);

  const filterCompanies = (search = keyword) => {
    let url = new URL(`${process.env.REACT_APP_BASE_URL_API}/companies`);
    url.searchParams.set("isPartner", 1);
    url.searchParams.set("name", search);
    url.searchParams.set("itemsPerPage", itemsPerPage);
    setUrl(url);
  };

  return (
    <div className="universites">
      <Header />
      {!props.auth.isConnected && (
        <div className="universites__container">
          <div className="universites__container__top">
            <div className="universites__container__top__title">
              <h1 className="h1_trait_dessus">
                Comment rejoindre Réseau Pro ?
              </h1>
            </div>
            <div>
              {props.admin.editManagement.length > 0 &&
                parse(
                  sanitizeHtml(
                    findManagementContentByLabel(
                      "rejoindreRP",
                      props.admin.editManagement,
                      props.admin.editManagementNexus
                    ).content || "rejoindreRPDefault"
                  ),
                  HTMLParseOptions
                )}
            </div>
            <div className="universites__container__top__boutons">
              <BtnBleu
                btnTexte="Se connecter"
                btnAction={() =>
                  (window.location.href = "http://reseaupro.unpidf.fr/")
                }
              />
              <BtnBlanc
                btnTexte="Créer un compte"
                btnAction={() =>
                  (window.location.href = "http://reseaupro.unpidf.fr/")
                }
              />
            </div>
          </div>
          <div className="universites__container__bottom">
            <div className="universites__container__bottom__title">
              <h1 className="h1_trait_dessus">Les entreprises Réseau Pro</h1>
              <span className="container_input_entreprises">
                <HiSearch className="search_icon_entreprises" />
                <InputText
                  placeholder="Rechercher une entreprise"
                  className="company_search"
                  onChange={(e) => {
                    setKeyword(e.target.value);
                    e.target.value === "" && filterCompanies("");
                  }}
                  onKeyDown={(e) => {
                    e.key === "Enter" && filterCompanies();
                  }}
                />
              </span>
            </div>

            <div
              className="universites__container__bottom__entreprises"
              ref={refCompany}
            >
              {companiesQuery.loaded ? (
                companiesQuery.data?.length > 0 ? (
                  companiesQuery.data.map((company) => (
                    <div key={company.id} onClick={() => setLoginVisible(true)}>
                      <EntrepriseCard
                        nomEntreprise={company?.name}
                        type={company?.structure?.label ?? company?.type?.label}
                        imageLogo={company.logo || "entreprise2"}
                        imageFond={"entrepriseFond2"}
                        taille={company?.totalStaff?.label ?? "Non renseigné"}
                        offresDisponibles
                        isPartner
                      />
                    </div>
                  ))
                ) : (
                  <span>Aucune entreprise n&apos;a été trouvée</span>
                )
              ) : (
                <Loader></Loader>
              )}
            </div>

            <TempPagination
              result={companiesQuery.data}
              refItemParent={refCompany}
              rows={itemsPerPage}
            />
          </div>
        </div>
      )}
      {loginVisible && (
        <ModalConnexion
          visibleModal={loginVisible}
          setVisibleModal={setLoginVisible}
        ></ModalConnexion>
      )}
      <Footer />
    </div>
  );
};

Entreprises.propTypes = {
  auth: PropTypes.object,
  admin: PropTypes.object,
  rejoindreRP: PropTypes.string,
  pagination: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
  companies: PropTypes.object,
  offers: PropTypes.object,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  rejoindreRP: state.admin.editManagement.rejoindreRP,
  admin: state.admin,
  pagination: state.pagination,
  companies: state.companies,
  offers: state.offers,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdatePagination: (value) => {
    dispatch(updatePagination(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Entreprises);
